import React, { useEffect, useState } from 'react';
import Header from '../../Core/Header';
import { Section } from '../../Core/Section';
import { assignCustomizedBooking, getServiceBoyList, gstAllCustomizedBooking } from '../../Services/Operations/ProductAPI';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';


const CustomizedRequest = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);
  const [allCustomizedBoking, setAllCustomizedBooking] = useState([]);
  const [serviceBoys, setServiceBoys] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentUsers = allCustomizedBoking.slice(indexOfFirst, indexOfLast);

  const fetchServieBoys = async () => {
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const response = await getServiceBoyList(token);
      console.log("serice boy  List: ", response);
      setServiceBoys(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAllCustomizedBooking = async () => {
    try {
      const response = await gstAllCustomizedBooking(token);
      console.log(response);
      if (response.status === 200) {
        setAllCustomizedBooking(response.data.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleAllCustomizedBooking();
    fetchServieBoys();
  }, []);

  const handleAssignServiceBoy = async (serviceBoyId, customizedBookingId) => {
    try {
      setLoading(serviceBoyId);
      const response = await assignCustomizedBooking(token, serviceBoyId, customizedBookingId);

      console.log(response);
      if (response.status === 200) {
        toast.success("Service person assigned successfully");
        setModal(null);
        handleAllCustomizedBooking();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="main_content" className="custom-request-page">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body cr-section-body">
          <div className="container-fluid cr-container">
            <div className="cr-page-heading">
              <div>
                <div className="cr-eyebrow"><span className="cr-eyebrow-dot" /> OPERATIONS MANAGEMENT</div>
                <h1 className="cr-title">Customized Requests</h1>
                <p className="cr-subtitle">Review customer requests and assign a service person to each order.</p>
              </div>
              <div className="cr-heading-count">
                <span className="cr-count-icon"><i className="fa fa-clipboard-list" /></span>
                <span><b>{allCustomizedBoking.length}</b><small>Total requests</small></span>
              </div>
            </div>

            <div className="cr-content-card">
              <div className="cr-card-heading">
                <div>
                  <h2>Request Overview</h2>
                  <p>All customized product bookings are listed below.</p>
                </div>
                <div className="cr-record-count">
                  <span className="cr-record-dot" />
                  {allCustomizedBoking.length} records
                </div>
              </div>

              <div className="cr-table-wrap">
                <table className="cr-table">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Product Name</th>
                      <th>Price</th>
                      <th>Date</th>
                      <th>Image</th>
                      <th>Quantity</th>
                      <th>Total Amount</th>
                      <th>Grand Total</th>
                      <th>View Test Data</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allCustomizedBoking.length > 0 && currentUsers.map((item, ind) => (
                      <tr key={item.id || ind}>
                        <td><span className="cr-id">#{indexOfFirst + ind + 1}</span></td>
                        <td><span className="cr-product-name">{item?.productName}</span></td>
                        <td>₹{item?.price}</td>
                        <td>
                          <span className="cr-date">{item?.createdAt[2]}/{item?.createdAt[1]}/{item?.createdAt[0]}</span>
                          <span className="cr-time">{item?.createdAt[3]}:{item?.createdAt[4]}</span>
                        </td>
                        <td>
                          <p className="cr-image-label"> <i className="fa fa-picture-o" /> {"images"}()</p>
                        </td>
                        <td>{item?.quantity}</td>
                        <td>₹{item?.totalAmount}</td>
                        <td><span className="cr-grand-total">₹{item?.grandTotal}</span></td>
                        <td>
                          <button
                            onClick={() => navigate(`/customized-booking-test-data/${item.id}`)}
                            className="cr-icon-btn cr-view-btn"
                            title="View test data"
                          >
                            <i className="fa fa-eye" />
                          </button>
                        </td>
                        <td>
                          {item.servicePersonStatus === 'ASSIGNED' ? (
                            <button
                              onClick={() => { toast.info("This order is already Assigned"); }}
                              className="cr-assigned-btn"
                            >
                              <i className="fa fa-check-circle" /> Done
                            </button>
                          ) : (
                            <button
                              onClick={() => { setModal(item); }}
                              className="cr-assign-btn"
                            >
                              <i className="fa fa-user-plus" /> Assign
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                    {allCustomizedBoking.length === 0 && (
                      <tr>
                        <td colSpan="10" className="cr-empty-cell">
                          <span className="cr-empty-icon"><i className="fa fa-inbox" /></span>
                          <b>No customized requests found</b>
                          <small>New customer requests will appear here.</small>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="cr-pagination">
                <span className="cr-page-info">
                  Showing {allCustomizedBoking.length === 0 ? 0 : indexOfFirst + 1}–{Math.min(indexOfLast, allCustomizedBoking.length)} of {allCustomizedBoking.length}
                </span>
                <div className="cr-page-controls">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="cr-page-btn"
                  >
                    <i className="fa fa-chevron-left" /> Prev
                  </button>
                  <span className="cr-page-number">Page <b>{currentPage}</b> of {Math.ceil(allCustomizedBoking.length / itemsPerPage)}</span>
                  <button
                    disabled={currentPage === Math.ceil(allCustomizedBoking.length / itemsPerPage)}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="cr-page-btn"
                  >
                    Next <i className="fa fa-chevron-right" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {modal && (
            <div className="cr-modal-overlay">
              <div className="cr-modal-content">
                <div className="cr-modal-header">
                  <div className="cr-modal-heading-icon"><i className="fa fa-users" /></div>
                  <div>
                    <h3>Select a Service Person</h3>
                    <p>Choose a team member for this customized request.</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => setModal(null)}
                    className="cr-modal-close"
                    aria-label="Close"
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>

                <div className="cr-selected-request">
                  <span>REQUEST</span>
                  <b>#{modal.id}</b>
                  <small>{modal.productName}</small>
                </div>

                <div className="cr-service-list">
                  {serviceBoys.length > 0 && serviceBoys.map((item) => (
                    <div
                      key={item.employeeId}
                      onClick={() => handleAssignServiceBoy(item.employeeId, modal.id)}
                      className={`cr-service-person ${loading === item.employeeId ? 'is-loading' : ''}`}
                      style={{ cursor: loading === item.employeeId ? 'not-allowed' : 'pointer' }}
                    >
                      <div className="cr-person-avatar">
                        {item.firstName?.charAt(0)?.toUpperCase()}
                      </div>
                      <div className="cr-person-details">
                        <p>{item.firstName}<span>{item.villageTownCity}</span></p>
                        <small><i className="fa fa-map-marker" /> From: {item.district}</small>
                      </div>
                      <div className="cr-person-action">
                        {loading === item.employeeId
                          ? <span className="cr-loading-text">Loading...</span>
                          : <i className="fa fa-chevron-right" />}
                      </div>
                    </div>
                  ))}
                  {serviceBoys.length === 0 && (
                    <div className="cr-no-service-boys">
                      <i className="fa fa-user-times" />
                      <span>No service persons available.</span>
                    </div>
                  )}
                </div>

                <div className="cr-modal-footer">
                  <button type="button" onClick={() => setModal(null)} className="cr-cancel-btn">Cancel</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomizedRequest;
